export default class ClickLink {
    static init(): void {
        this.handleLinks();
    }

    static handleLinks(): void {
        const links = document.querySelectorAll('[data-click-link]');
        links.forEach((link) => {
            link.addEventListener('click', (e) => {
                const clickedElement = e.target as HTMLElement;
                const unclicableLink = clickedElement.closest('[data-unclickable-link]');
                if (unclicableLink) return;

                const target = link.getAttribute('data-click-link');

                if (!target) return;

                if (target.startsWith('#')) {
                    const targetElement = document.querySelector(target);
                    if (!targetElement) return;
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                } else {
                    window.location.href = target;
                }
            });
        });

    }


}
